module.exports = __webpack_public_path__ + "f5d908d1f595738bdf265f2b7ffdcd7e.svg";